import React from 'react'
import { Link } from 'react-router-dom'

import styles from './TrialBanner.module.css'

const ONE_DAY = 24 * 60 * 60 * 1000

export default function TrialBanner({ organization }) {
  const diff = new Date(organization.trialEndsAt) - new Date()

  const daysRemaining = Math.max(0, Math.round(diff / ONE_DAY))

  return (
    <div className={styles.banner}>
      <p>
        {`${daysRemaining} ${
          daysRemaining === 1 ? 'day' : 'days'
        } remaining in your trial. `}
        <Link to="/subscribe">Upgrade Now »</Link>
      </p>
    </div>
  )
}
